import styled from 'styled-components';

/** @component */
export default styled.header`
  width: 220px;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: ${props => props.theme.palette.primary.dark};

  @media (max-width: 768px) {
    flex-direction: row;
    width: 100%;
    position: relative;
    overflow: auto;
    min-height: 56px;
  }
`;
